import { InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { shallowEqual } from "react-redux";
import { Dayjs } from "dayjs";
import { Contractor } from "../../../../../../services/subcontractor/get-all/types";
import { useMutation } from "@tanstack/react-query";
import { getAllSubcontractor } from "../../../../../../services/subcontractor/get-all";
import { putSubcontractorUpdate } from "../../../../../../services/subcontractor/update";
import { nipRegExp, phoneRegExp } from "../../../../../../utils/regex";
import * as yup from "yup";
import { PutSubcontractorUpdateRequestBody } from "../../../../../../services/subcontractor/update/types";
import { setTimezoneDate } from "../../../../../common-views/offer-form-summary/components/submit-an-inquiry-button/helpers";
import { StyledButton } from "../../../../../../components/Button/button";
import { theme } from "../../../../../../helpers/theme";
import { Input } from "../../../../../../components/Input/input";
import { SuccessMessage } from "../../forms-wraper/helpers/success-message";
import { RequiredInfo } from "../../forms-wraper/helpers/required-info";

interface SubcontractorDataEditeProps {
    id: string,
    nazwa_wykonawcy: string,
    nip: string,
    telefon: string,
    email: string,
    aktywny: boolean,
    aktywny_data_do?: Dayjs | null;
    adres_id: string | null,
    handleClose: () => void;
    setSubcontractors: (element: Contractor[]) => void;
}

type SubcontractorDataEditeTestedValue = {
    nazwa_wykonawcy: string,
    nip: string,
    telefon: string,
    email: string,
    aktywny: boolean,
};


export const SubcontractorDataEdite = (
    {
        id,
        nazwa_wykonawcy,
        nip,
        telefon,
        email,
        aktywny,
        aktywny_data_do,
        adres_id,
        handleClose,
        setSubcontractors,

    }: SubcontractorDataEditeProps) => {
    const [openSuccessInfo, setOpenSuccessInfo] = useState(false);

    const [isActive, setIsActive] = useState(`${aktywny === true ? 0 : 1}`);
    const [_isActiveCopy, set_IsActiveCopy] = useState(isActive);

    const [toDate, setToDate] = useState<Dayjs | null>(null);


    //Weryfikacja zmiany danych o wyslaniu

    const startedFormValues: SubcontractorDataEditeTestedValue = {
        nazwa_wykonawcy,
        nip,
        telefon,
        email,
        aktywny: Number(_isActiveCopy) === 0 ? true : false,
    }

    const [startedValues, setStartedValues] = useState(startedFormValues);
    const [isDataChange, setIsDataChange] = useState(false);


    const compareValuesInFormWithStartedValues = (values: SubcontractorDataEditeTestedValue, newValues: SubcontractorDataEditeTestedValue) => {
        return !shallowEqual(values, newValues);
    }


    const handleClick = () => {
        setOpenSuccessInfo(true);
    };

    const handleChangeIsActive = (event: SelectChangeEvent) => {
        setIsActive(event.target.value as string);

    };


    const reGetAllSubcontractor = useMutation(getAllSubcontractor, {
        onSuccess: (data) => {
            setSubcontractors(data.data.payload.wykonawcy);
        },
    });

    const editSubcontractorDataMutation = useMutation(putSubcontractorUpdate, {

        onSuccess: (res) => {
            reGetAllSubcontractor.mutate({
                paginacja: null,
            })

            set_IsActiveCopy(isActive);
            setStartedValues({
                nazwa_wykonawcy: formik.values.nazwa_wykonawcy,
                nip: formik.values.nip,
                telefon: formik.values.telefon,
                email: formik.values.email,
                aktywny: Number(isActive) === 0 ? true : false,
            });
            setIsDataChange(false);
            handleClick();//InfoSuccess
            //setIsEditedDisable(true) //Visible Button Suubmit

        },
    });

    const validationSchema = yup.object({
        email: yup
            .string()
            .required("E-mail jest wymagany")
            .email("Błędny format adresu E-mail")
            .max(50, "Maksymalnie 50 znaków"),
        nip: yup
            .string()
            .required("NIP jest wymagany")
            .matches(nipRegExp, "Błędny format!")
            .min(10, "Błędny format!")
            .max(10, "Błędny format!"),
        telefon: yup
            .string()
            .required("Telefon jest wymagany")
            .matches(phoneRegExp, "Błędny format!")
            .min(9, "Błędny format!")
            .max(9, "Błędny format!"),
        nazwa_wykonawcy: yup
            .string()
            .required("Nazwa firmy jest wymagana")
            .max(50, "Maksymalnie 50 znaków"),
        aktywny: yup
            .boolean()
            .required("Pole wymagane")
    });


    const formik = useFormik({
        initialValues: {
            id,
            nazwa_wykonawcy,
            nip: nip,
            telefon: telefon,
            email,
            aktywny,
            aktywny_data_do: aktywny_data_do ? aktywny_data_do : null,
            adres_id,
        },
        validationSchema: validationSchema,

        onSubmit: (values: PutSubcontractorUpdateRequestBody) => {


            setIsDataChange(compareValuesInFormWithStartedValues(startedValues, {
                nazwa_wykonawcy: values.nazwa_wykonawcy,
                nip: values.nip,
                telefon: values.telefon,
                email: values.email,
                aktywny: Number(isActive) === 0 ? true : false,
            }));

            const body = {
                id: values.id,
                nazwa_wykonawcy: values.nazwa_wykonawcy,
                nip: values.nip,
                telefon: values.telefon,
                email: values.email,
                aktywny: Number(isActive) === 0 ? true : false,
                aktywny_data_do: toDate ? setTimezoneDate(toDate) : null,
                adres_id: values.adres_id,

            }

            if (isDataChange) {
                editSubcontractorDataMutation.mutate(body)
            }

        },
    });

    useEffect(() => {
        // if (isEditedDisable === true) {
        //     setIsEditedDisable(false);
        // }
        setIsDataChange(compareValuesInFormWithStartedValues(startedValues, {
            nazwa_wykonawcy: formik.values.nazwa_wykonawcy,
            nip: formik.values.nip,
            telefon: formik.values.telefon,
            email: formik.values.email,
            aktywny: Number(isActive) === 0 ? true : false,
        }))

    }, [formik.values]);




    useEffect(() => {
        setIsDataChange(!(isActive === _isActiveCopy));
    }, [isActive]);




    return (
        <Container>
            <form
                onSubmit={formik.handleSubmit}
                onChange={() => setIsDataChange(compareValuesInFormWithStartedValues(startedValues, {
                    nazwa_wykonawcy: formik.values.nazwa_wykonawcy,
                    nip: formik.values.nip,
                    telefon: formik.values.telefon,
                    email: formik.values.email,
                    aktywny: Number(isActive) === 0 ? true : false,
                }))}>
                <SumamryWraper key="Nazwa">
                    <SummaryItemValue>
                        <Input
                            label="Nazwa*"
                            id="nazwa_wykonawcy"
                            name="nazwa_wykonawcy"
                            value={formik.values.nazwa_wykonawcy}
                            onChange={formik.handleChange}
                            error={formik.touched.nazwa_wykonawcy && Boolean(formik.errors.nazwa_wykonawcy)}
                            helperText={formik.touched.nazwa_wykonawcy && formik.errors.nazwa_wykonawcy}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper >
                <SumamryWraper key="NIP">
                    <SummaryItemValue>
                        <Input
                            label="NIP*"
                            id="nip"
                            name="nip"
                            value={formik.values.nip}
                            onChange={formik.handleChange}
                            error={formik.touched.nip && Boolean(formik.errors.nip)}
                            helperText={formik.touched.nip && formik.errors.nip}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Telefon">
                    <SummaryItemValue>
                        <Input
                            label="Telefon*"
                            id="telefon"
                            name="telefon"
                            value={formik.values.telefon}
                            onChange={formik.handleChange}
                            error={formik.touched.telefon && Boolean(formik.errors.telefon)}
                            helperText={formik.touched.telefon && formik.errors.telefon}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="E-mail">
                    <SummaryItemValue>
                        <Input
                            label="E-mail*"
                            id="email"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="Umowa aktywna" style={{ top: "25px", marginTop: "-16px" }}>
                    <SummaryItemValue>
                        <InputLabel sx={{
                            color: `#00000099`,
                            fontSize: "11px",
                            font: `${theme.fonts.interRegular}`,
                            top: "25px",
                            left: "12px",
                            zIndex: "100000",

                        }}
                        >Umowa aktywna</InputLabel>
                        <Select
                            name="aktywny"
                            id="aktywny"
                            value={isActive}
                            onChange={handleChangeIsActive}
                            variant="filled"
                            disableUnderline //usuwa podkreslenie
                            sx={{
                                width: "100%",
                                backgroundColor: `white`,
                                borderRadius: "8px",
                                "& .Mui-disabled": {
                                    backgroundColor: `${theme.colors.gray05_input}`,
                                    borderRadius: "8px",
                                },
                                "&.active, &:hover, &.active:hover": {
                                    backgroundColor: `white`,
                                    borderRadius: `8px`,

                                },
                            }}
                        >
                            <MenuItem value={'0'} >Tak</MenuItem>
                            <MenuItem value={'1'} >Nie</MenuItem>
                        </Select>

                    </SummaryItemValue>
                </SumamryWraper >
                < RequiredInfo text={"Pola wymagane"} />
                < SuccessMessage
                    message={"Dane podwykonawcy zostały zmienione"}
                    setOpenSuccessInfo={setOpenSuccessInfo}
                    openSuccessInfo={openSuccessInfo}
                />
                <ButtonWraper>
                    <StyledButton
                        type="submit"
                        variant="contained"
                        sx={{
                            marginTop: "16px",
                            marginBottom: "16px",
                            marginLeft: "auto",
                            width: "150px",
                        }}

                        //disabled={isEditedDisable || !formik.isValid || editSubcontractorDataMutation.isLoading}
                        disabled={!isDataChange || editSubcontractorDataMutation.isLoading || !formik.isValid}
                    >
                        Zapisz
                    </StyledButton>
                </ButtonWraper>


            </form >
        </Container >
    );
};
const Container = styled.div`
width:100%;
font-family:${theme.fonts.interMedium},
`
const SumamryWraper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

const SummaryItemValue = styled.div`
padding: 5px 0px;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
overflow-wrap: break-word;
align-content: center;
white-space: break-spaces;
`;

const ButtonWraper = styled.div`
width:100%;
text-align:center;`
